import { render, staticRenderFns } from "./Commod.vue?vue&type=template&id=6172a9b8&scoped=true"
import script from "./Commod.vue?vue&type=script&lang=js"
export * from "./Commod.vue?vue&type=script&lang=js"
import style0 from "./Commod.vue?vue&type=style&index=0&id=6172a9b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6172a9b8",
  null
  
)

export default component.exports